var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.44 126.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ded062;}.cls-2{fill:#48c3d1;}.cls-3{fill:#f89e53;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.9,252.38c-10.29-12.73-31.66-21.16-49.62-12.83-18.66,8.65-27.82,29.29-27.82,29.29s19.42-20.82,34.75-5.42c7.53,7.56,9.34,8.61,17.58,8.84A28.18,28.18,0,0,0,446.16,268c.07-1.59-2.49-2.76-6.35-2.69s-15.48.9-15.67-5.37,13.94-7.7,19.61-3.82,12.5,11.26,18.89,17.81,8.51,7.62,10.41,5.52A157.32,157.32,0,0,0,455.9,252.38Zm-45.22-2.1,9.32.13c-7.44,5.62-15.17,5.05-23.33,2.31,9.24-11.17,20.64-13.59,30.42-5.92C420.62,245.65,415.43,246.4,410.68,250.28Z",
    transform: "translate(-357.24 -236.22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M464.47,287s2.53-4.83-10.59-18.66C453.88,268.29,456,284.78,464.47,287Z",
    transform: "translate(-357.24 -236.22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.51,263.76c.2,16.22,5.29,15.49,5.29,15.49C452.78,265.52,448.51,263.76,448.51,263.76Z",
    transform: "translate(-357.24 -236.22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M474.75,284.38s9.32,26.9-11.47,33.24c-10.21,3.12-12,4.22-16,11.4a28.22,28.22,0,0,0-3.4,15.59c1.37.81,3.6-.91,5.34-4.35s6.46-14.11,12.09-11.34.28,15.93-5.8,19.12-15.8,5.78-24.58,8.36-10.72,4-9.75,6.62a157.44,157.44,0,0,0,31.92-2.51c16.06-3.13,33.51-18.08,34.56-37.84C488.71,302.13,474.75,284.38,474.75,284.38Zm-3.28,53.28c4-5.17,5.81-10.11,4.61-16.13-1.63,3-3.05,5.58-4.48,8.18-1.49-9.2,2.63-15.77,8.87-21.7C486,321.4,482.83,332.61,471.47,337.66Z",
    transform: "translate(-357.24 -236.22)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M439.94,351.28s-15.54-5.87-21.44.63C418.5,351.91,421.58,356.4,439.94,351.28Z",
    transform: "translate(-357.24 -236.22)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.46,348.66c-14.43-7.41-16.17-2.58-16.17-2.58C442.91,351.61,446.46,348.66,446.46,348.66Z",
    transform: "translate(-357.24 -236.22)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.93,334.44c3.38-10.13,3.5-12.21,0-19.68A28.15,28.15,0,0,0,379.19,303c-1.45.65-1.34,3.47.45,6.88s7.77,13.43,2.25,16.42-13.15-9-12.23-15.81,4.44-16.22,7.42-24.88,3-11,.25-11.77a157.08,157.08,0,0,0-16.44,27.47c-6.75,14.91-4.67,37.79,10.83,50.09C387.84,364.14,410.39,363,410.39,363S383.07,355.06,389.93,334.44Zm-21.08-4.93c1.88,6.29,4.88,10.59,10.49,13.09-1.49-3-2.78-5.71-4.08-8.38,8.37,4.12,11.34,11.28,12.55,19.8C373.68,350.8,366.39,341.69,368.85,329.51Z",
    transform: "translate(-357.24 -236.22)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M387.91,278.08s-5.44-.1-11.9,17.84C376,295.92,389.8,286.65,387.91,278.08Z",
    transform: "translate(-357.24 -236.22)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M374.38,302.75c14.39-7.47,11.46-11.68,11.46-11.68C374,298.15,374.38,302.75,374.38,302.75Z",
    transform: "translate(-357.24 -236.22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7fa2b7f4677fcc733fc3a25fcf689233.svg";
export { ForwardRef as ReactComponent };